/**************************************************
 * Nombre:       Calculadora_Calculadora
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Calculadora from "../../Formularios/Formulario_Calculadora";
import Letra_Titulo from "./SubComponentes/Letra_Titulo";
import {useState} from "react";
import {calcularCuotas} from "../../../CodNegocio/Cuotas/calcularCuotas";
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Calculadora_Calculadora = () => {
    const {sCell} = useResponsive()
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const [numMeses, setNumMeses] = useState(0)
    const [valRendimiento, setValRendimiento] = useState(0)
    const [total, setTotal] = useState(0)
    const [calculos, setCalculos] = useState(0)

    const calcular = async () => {

        let entidad = await obtenerEntidad()
        let valorCuota = calcularCuotas({meta: entidad.valor, meses: entidad.numMeses, tasaMensual: 1})
        let valorAhorrado = valorCuota * entidad.numMeses
        let valorRendimientos = entidad.valor - valorAhorrado
        setCalculos({
            valorCuota: valorCuota,
            valorAhorrado: valorAhorrado,
            valorRendimientos: valorRendimientos,
            total: valorRendimientos + valorAhorrado,
            valorAccidente: 20000000,
            numMeses: entidad.numMeses,
        })
        setNumMeses(entidad.numMeses)


    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: 6}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 42, fontWeight: 600}}>Calculadora</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 18, fontWeight: 400}}>Proyecta tus ahorros y mira hasta dónde
                                puedes llegar</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 8}}>
                            <Formulario_Calculadora props={props}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 2}}
                              spacing={2}
                        >
                            <Button
                                onClick={() => calcular()}
                                sx={{px: 3}}>Calcular</Button>

                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt:sCell ? 4 : 0}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: '#000',
                            p: 4,
                            borderRadius: 6,
                            color: '#fff'
                        }}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 24, fontWeight: 600, lineHeight: 1.1}}>Mira como alcanzas tu
                                objetivo</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400}}>Da forma a tu futuro y mira cómo cada
                                aporte te impulsa más lejos</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', pb: 6, mt: 6}}>
                            <Letra_Titulo titulo={'Total en tu cuenta'} numero={calculos.total ? formatoMoneda(calculos.total) : 0}
                                          grande={true}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start', mt: sCell ? 0 :  6}}>
                            <Letra_Titulo titulo={'Meses'} numero={calculos.numMeses ? calculos.numMeses : 0}
                                          grande={true}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: sCell ? 2 :  0}}>
                            <Letra_Titulo titulo={'Rendimientos'}
                                          numero={calculos.valorRendimientos ? formatoMoneda(calculos.valorRendimientos) : 0}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: sCell ? 2 :  0}}>
                            <Letra_Titulo titulo={'En caso de accidente'}
                                          numero={calculos.total && calculos.total > 500000 ? formatoMoneda(calculos.valorAccidente) : 0}/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Calculadora_Calculadora  